import { ClockClient } from './clock-client';
export default function ClockPage() { return <ClockClient />; }
